import axios from 'axios';
import {properties} from '../resources/properties.js';

const API_URL = properties.apiURLMaths;
const semiejeMayor = 6378137;
const aplanamiento = 1 / 298.257;
const K0 = 0.9996;

const getGRS80 = () => {
  const elipsoide = [];
  elipsoide[0] = semiejeMayor;
  elipsoide[1] = aplanamiento;
  elipsoide[2] = elipsoide[0] - (elipsoide[0] * elipsoide[1]);
  elipsoide[3] = Math.sqrt((elipsoide[0] ** 2 - elipsoide[2] ** 2) / elipsoide[0] ** 2);
  elipsoide[4] = Math.sqrt((elipsoide[0] ** 2 - elipsoide[2] ** 2) / elipsoide[2] ** 2);
  return elipsoide;
}

export const getConvUTM = (lon, lat, huso) => {
  const result = [];
  const elipsoide = getGRS80();
  // const semiejeMayor = elipsoide[0];
  // const primeraExcentricidad = (elipsoide[0] ** 2 - elipsoide[2] ** 2) / elipsoide[0] ** 2;
  const primeraExcentricidad = (elipsoide[0] ** 2 - elipsoide[2] ** 2) / elipsoide[0] ** 2;
  const segundaExcentricidad = (elipsoide[0] ** 2 - elipsoide[2] ** 2) / elipsoide[2] ** 2;
  // const ilo = lon - 6 * (huso - 30.5);
  // const ilo_rad = degreesToRadians(ilo);
  // const lat_rad = degreesToRadians(lat);
  // const Nmay = semiejeMayor / ((1 - primeraExcentricidad * (Math.sin(lat_rad)) ** 2)) ** 0.5;
  // const b = semiejeMayor * (1 - primeraExcentricidad) * ((1 + 3 / 4 * primeraExcentricidad + 45 / 64 * primeraExcentricidad ** 2 + 175 / 256 * primeraExcentricidad ** 3) *
  //   lat_rad - 0.5 * (3 / 4 * primeraExcentricidad + 15 / 16 * primeraExcentricidad ** 2 + 525 / 512 * primeraExcentricidad ** 3) * Math.sin(2 * lat_rad) +
  //   0.25 * (15 / 64 * primeraExcentricidad ** 2 + 105 / 256 * primeraExcentricidad ** 3) * Math.sin(4 * lat_rad) - 1 / 6 * (35 / 512 * primeraExcentricidad ** 3) * Math.sin(6 * lat_rad));
  // const n = segundaExcentricidad ** 0.5 * Math.cos(lat_rad);
  // let y = b + ilo_rad ** 2 / 2 * Nmay * (Math.cos(lat_rad)) ** 2 * Math.tan(lat_rad) + ilo_rad ** 4 / 24 * Nmay * (Math.cos(lat_rad)) ** 4 * Math.tan(lat_rad) *
  //   (5 - Math.tan(lat_rad) * Math.tan(lat_rad) + 9 * n ** 2 + 4 * n ** 4) + ilo_rad ** 6 / 720 * Nmay * (Math.cos(lat_rad)) ** 6 * Math.tan(lat_rad) * (61 - 58 * (Math.tan(lat_rad)) ** 2 +
  //     (Math.tan(lat_rad)) ** 4 + 270 * n ** 2 - 330 * (Math.tan(lat_rad)) ** 2 * n ** 2);
  // y = y * K0;
  // if (lat < 0) {
  //   y = y + 10000000;
  // }
  // let x = ilo_rad * Nmay * Math.cos(lat_rad) + ilo_rad ** 3 / 6 * Nmay * (Math.cos(lat_rad)) ** 3 * (1 - (Math.tan(lat_rad)) ** 2 + n ** 2) + ilo_rad ** 5 / 120 * Nmay * (Math.cos(lat_rad)) ** 5 *
  //   (5 - 18 * (Math.tan(lat_rad)) ** 2 + (Math.tan(lat_rad)) ** 4 + 14 * n ** 2 - 58 * (Math.tan(lat_rad)) ** 2 * n ** 2);
  // x = x * K0 + 500000;
  // const k = K0 * (1 + ilo_rad ** 2 / 2 * Math.cos(lat_rad) * Math.cos(lat_rad) * (1 + (primeraExcentricidad / (1 - primeraExcentricidad) * Math.cos(lat_rad) * Math.cos(lat_rad))));
  // const lonrad1 = lon * Math.PI / 180 - ((6 * huso - 183) * Math.PI / 180);

  // let conv = lonrad1 * Math.sin(lat_rad) + (lonrad1 ** 3 * Math.sin(lat_rad) * (Math.cos(lat_rad)) ** 2 / 3) * (1 + 3 * mu ** 2 + 2 * mu ** 4)
  // conv = conv * 180 / Math.PI;
  // conv = conv * 3600;
  // conv = seconds_to_degrees(conv);

  // return result;
  const latRadians = lat * Math.PI / 180.0;
  const ilo = lon - 6 * (huso - 30.5);
  const ilRad = ilo * Math.PI / 180.0;

  const tangente = Math.tan(latRadians);
  const coseno = Math.cos(latRadians);
  const seno = Math.sin(latRadians);
  const mu = segundaExcentricidad * Math.cos(latRadians);
  const conv = ilRad * seno + (ilRad ** 3 / 3) * seno * coseno ** 2 * (1 + 3 * mu ** 2 + 2 * mu ** 4) + (ilRad ** 5 / 15) * seno * coseno ** 4 * (2 - tangente ** 2);

  let convSeconds = (conv * 180.0 / Math.PI) * 3600;
  const sign = convSeconds >= 0
    ? ''
    : '-';
  convSeconds = Math.abs(convSeconds);
  let convDegrees = Math.floor(convSeconds / 3600);
  let convMinutes = Math.floor((convSeconds - (convDegrees * 3600)) / 60);
  let trueSeconds = Math.round(convSeconds - (convDegrees * 3600) - (convMinutes * 60));
  const trueConv = sign + convDegrees + 'º' + convMinutes + "'" + trueSeconds + "''";
  const K = K0 * (1 + ilRad ** 2 / 2.0 * coseno ** 2 * (1 + (primeraExcentricidad / (1 - primeraExcentricidad) * coseno ** 2)));
  result.push(K);
  result.push(trueConv);
  // const conv1 = (il * seno) + (((il ** 3) / 3) * seno * (coseno ** 2) * (1 + (3 * (mu ** 2)) + 2 * (mu ** 4))) + (((il ** 5) / 15) * seno * (coseno ** 4) * ((2 - (tangente ** 2)) + (15 * (mu ** 2)) - (15 * ((mu ** 2) * (tangente ** 2))) + (35 * (mu ** 4)) - (50 * (mu ** 4) * (tangente ** 2)) + (33 * (mu ** 6)) - (60 * (mu ** 6) * (tangente ** 2)) + (11 * (mu ** 8)) - (24 * (mu ** 8) * (tangente ** 2))));
  // const conv21 = ((il ** 7) / 5040) * seno * (coseno ** 6);
  // const conv22 = (-148 - (3427 * (tangente ** 2)) + (18 * (tangente ** 4)) - (1387 * (tangente ** 6)) + (2023 * (mu ** 2)) - (46116 * (mu ** 2) * (tangente ** 2)) + (5166 * (mu ** 2) * (tangente ** 4)) + (18984 * (mu ** 4)) - (100212 * (mu ** 4) * (tangente ** 2)) + (57624 * (mu ** 4) * (tangente ** 4)));
  // const conv23 = ((34783 * (mu ** 6)) - (219968 * (mu ** 6) * (tangente ** 2)) + (144900 * (mu ** 6) * (tangente ** 4)) + (36180 * (mu ** 8)) - (261508 * (mu ** 8) * (tangente ** 2)) + (155904 * (mu ** 8) * (tangente ** 4)) + (18472 * (mu ** 10)) - (114528 * (mu ** 10) * (tangente ** 2)) + (94080 * (mu ** 10) * (tangente ** 4)) + (4672 * (mu ** 12)) - (30528 * (mu ** 12) * (tangente ** 2)) + (23040 * (mu ** 12) * (tangente ** 4)));
  // const conv2 = conv21 * (conv22 + conv23);
  // const conv = conv1 + conv2;

  // const XII = seno * Math.pow(10, 4);

  // const result2 = seconds_to_degrees(result);

  // const lonConvut = lon * 60 * 60;
  // const segundaExcentricidad = 0.0820944384413463;
  // const senoDeUnSegundo = Math.sin(seconds_to_radians(1));
  // const mu = segundaExcentricidad * coseno;
  // let il = degreesToRadians(lon - (6 * (huso - 30.5)));
  // const XII = seno * (10 ** 4);
  // const XIII = (1 / 3) * (seno * (coseno ** 2) * (1 + (3 * (mu ** 2)) + (2 * (mu ** 4))) * (senoDeUnSegundo ** 2) * Math.pow(10, 12));
  // const c5 = (1 / 15) * (seno * (coseno ** 4) * (2 - (tangente ** 2)) * (il ** 5) * (senoDeUnSegundo ** 4) * (10 ** 20));
  //  const conv = XII * il + XIII * Math.pow(il, 3) + c5;
  // const XX = (1 / 2) * ((coseno ** 2) * (senoDeUnSegundo ** 2) * (1 + (mu ** 2)) * (10 ** 8));
  // const k = K0 * (1 + (XX * (il ** 2)));
  // result.push(k);
  result.push(conv);
  return result;
}

export const getDeclinacionMagnetica = (lon, lat) => {
  let today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const yyyy = today.getFullYear();

  today = dd + '/' + mm + '/' + yyyy;
  const lonAbs = Math.abs(lon);
  const lonDegrees = Math.floor(lonAbs);
  const lonMinutes = Math.floor((lonAbs - lonDegrees) * 60);
  const lonAbsMinutes = (lonAbs - lonDegrees) * 60;
  const lonSeconds = Math.round((lonAbsMinutes - lonMinutes) * 60);
  const latAbs = Math.abs(lat);
  const latDegrees = Math.floor(latAbs);
  const latMinutes = Math.floor((latAbs - latDegrees) * 60);
  const latAbsMinutes = (latAbs - latDegrees) * 60;
  const latSeconds = Math.round((latAbsMinutes - latMinutes) * 60);
  let selectEO;
  if (lon <= 0.0) {
    selectEO = "O";
  } else {
    selectEO = "E";
  }
  const URLFinale = API_URL + 'startDate=' + today + '&textLon=' + lon + '&textLat=' + lat + '&textGradLon=' + lonDegrees + '&textMinLon=' + lonMinutes + '&textSegLon=' + lonSeconds + '&selectEO=' + selectEO + '&textGradLat=' + latDegrees + '&textMinLat=' + latMinutes + '&textSegLat=' + latSeconds;
  const headers = {};
  headers['Accept-Language'] = 'es';
  headers["Content-Type"] = 'application/json';

  return axios({method: 'get', url: URLFinale, headers: headers}).then(throwlessCheckStatus);
};

const throwlessCheckStatus = (response) => {
  if (response.status >= 200 && response.status < 300) { // Success status lies between 200 to 300
    return response;
  } else {
    console.error("ERROR getDeclinacionMagnetica", response.status , new Error(response.statusText));
    if (!(typeof response.data === "string")) {
      response.data = "NO STRING DATA REPLACEMENT";
    }
    return response;
  }
}

const checkStatus = (response) => {
  // raises an error in case response status is not a success
  if (response.status >= 200 && response.status < 300) { // Success status lies between 200 to 300
    return response;
  } else {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
};

export const getAnamorfisLineal = (lon, lat, huso) => {
  const elipsoide = getGRS80();
  const lonConvut = lon * 60 * 60;
  let il;
  if (huso > 30) {
    il = (lonConvut - (((huso - 31) * 6 + 3)) * 3600) / 10000;
  } else if (huso === 30) {
    il = (lonConvut - (((30 - huso) * 6 - 3)) * 3600) / 10000;
  } else {
    il = (lonConvut + (((30 - huso) * 6 - 3)) * 3600) / 10000;
  }
  const latRadians = degreesToRadians(lat);
  const coseno = Math.cos(latRadians);
  const senoDeUnSegundo = Math.sin(seconds_to_radians(1));
  const mu = elipsoide[4] * coseno;
  const XX = 0.5 * Math.pow(coseno, 2) * Math.pow(senoDeUnSegundo, 2) * (1 + Math.pow(mu, 2)) * Math.pow(10, 8);
  const K = K0 * (1 + (XX * Math.pow(il, 2)));
  return K;
}

export const getPNOADate = (extent) => {
  const QUERY_URL = `https://www.ign.es/wms-inspire/pnoa-ma?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetFeatureInfo&FORMAT=image%2Fpng&TRANSPARENT=true&QUERY_LAYERS=OI.MosaicElement&LAYERS=OI.MosaicElement&STYLES=&INFO_FORMAT=application/json&FEATURE_COUNT=1&BUFFER=10&I=50&J=50&CRS=EPSG%3A3857&WIDTH=101&HEIGHT=101&BBOX=`;
  const URLFinale = `${QUERY_URL}${extent[0]}%2C${extent[1]}%2C${extent[2]}%2C${extent[3]}`;
  const headers = {};
  headers['Accept-Language'] = 'es';
  headers["Content-Type"] = 'application/json';
  return axios({method: 'get', url: URLFinale, headers: headers}).then(checkStatus);
}

const seconds_to_radians = (seconds) => {
  return ((seconds / 60) / 60) * (Math.PI / 180);
}

const degreesToRadians = (degrees) => {
  return degrees * (Math.PI / 180);
}

/*const seconds_to_degrees = (seconds) => {
  const degrees = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds - (degrees * 3600)) / 60);
  const trueSeconds = Math.round(seconds - (degrees * 3600) - (minutes * 60));
  return degrees + 'º' + minutes + "'" + trueSeconds + "''";
}*/
